// CalendarComponent.tsx
import React, { useState } from 'react';
import * as S from './styles';

const getDaysInMonth = (year: number, month: number) => {
    const date = new Date(year, month, 1);
    const days = [];
    while (date.getMonth() === month) {
        days.push(new Date(date));
        date.setDate(date.getDate() + 1);
    }
    return days;
};

export const CalendarComponent: React.FC = () => {
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
    const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);

    // const days = getDaysInMonth(currentYear, currentMonth);

    const handleDayClick = (day: Date) => {
        if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
            setSelectedStartDate(day);
            setSelectedEndDate(null);
        } else if (selectedStartDate && !selectedEndDate) {
            setSelectedEndDate(day);
        }
    };

    const dayStartedOnWeekend = (day: Date) => {
        return day.getDay() === 0 || day.getDay() === 6;
    }

    const daysOnWeekend = (day: Date) => {
        const dayInWeek = day.getDay();
        switch (dayInWeek) {
            case 0:
                return 'Dom';
            case 1:
                return 'Seg';
            case 2:
                return 'Ter';
            case 3:
                return 'Qua';
            case 4:
                return 'Qui';
            case 5:
                return 'Sex';
            case 6:
                return 'Sáb';
            default:
                return '';
        }

    }


    const nameOfMonth = (month: number) => {
        switch (month) {
            case 0:
                return 'Jan';
            case 1:
                return 'Fev';
            case 2:
                return 'Mar';
            case 3:
                return 'Abr';
            case 4:
                return 'Mai';
            case 5:
                return 'Jun';
            case 6:
                return 'Jul';
            case 7:
                return 'Ago';
            case 8:
                return 'Set';
            case 9:
                return 'Out';
            case 10:
                return 'Nov';
            case 11:
                return 'Dez';
            default:
                return '';
        }
    }

    const handlePrevMonth = () => {
        setCurrentMonth(currentMonth - 1);
        if (currentMonth === 0) {
            setCurrentYear(currentYear - 1);
            setCurrentMonth(11);
        }
    };

    const handleNextMonth = () => {
        setCurrentMonth(currentMonth + 1);
        if (currentMonth === 11) {
            setCurrentYear(currentYear + 1);
            setCurrentMonth(0);
        }
    };

    const get42Days = (year: number, month: number) => {
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        const daysInMonth = lastDayOfMonth.getDate();
        const firstDayOfWeek = firstDayOfMonth.getDay();
        const lastDayOfWeek = lastDayOfMonth.getDay();

        const prevMonthDays = [];
        for (let i = 0; i < firstDayOfWeek; i++) {
            const prevMonthDay = new Date(year, month, -i);
            prevMonthDays.unshift(prevMonthDay);
        }

        const currentMonthDays = [];
        for (let i = 1; i <= daysInMonth; i++) {
            const currentMonthDay = new Date(year, month, i);
            currentMonthDays.push(currentMonthDay);
        }

        const nextMonthDays = [];
        const totalDaysNeeded = 42;
        const nextDaysNeeded = totalDaysNeeded - (prevMonthDays.length + currentMonthDays.length);
        for (let i = 1; i <= nextDaysNeeded; i++) {
            const nextMonthDay = new Date(year, month + 1, i);
            nextMonthDays.push(nextMonthDay);
        }

        return [...prevMonthDays, ...currentMonthDays, ...nextMonthDays];
    };

    const daysCurrentMonth = get42Days(currentYear, currentMonth);
    const daysNextMonth = get42Days(currentYear, currentMonth + 1);

    const isPrevOrNextMonth = (day: Date, currentMonth: number, currentYear: number) => {
        return day.getMonth() !== currentMonth || day.getFullYear() !== currentYear;
    };

    const isBeforeToday = (day: Date) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // set the time to 00:00:00.000
        return day < today;
    };

    console.log('selectedStartDate', selectedStartDate, 'selectedEndDate', selectedEndDate)

    function renderMonth(days: Date[], month: number) {
        return days.map((day, index) => {
            const isBefore = isBeforeToday(day);
            const isPrevOrNext = isPrevOrNextMonth(day, month, currentYear);
            const isSelectedStart = selectedStartDate && selectedStartDate.toString() === day.toString();
            const isSelectedEnd = selectedEndDate && selectedEndDate.toString() === day.toString();
            const isBetween = selectedStartDate && selectedEndDate && day > selectedStartDate && day < selectedEndDate;
            return (
                <S.DayButton daysStartedOnWeekend={dayStartedOnWeekend(day)} isBetween={isBetween as boolean} isPrevOrNext={isPrevOrNext} isSelectedEnd={isSelectedEnd as boolean} isSelectedStart={isSelectedStart as boolean} disabled={isBefore || isPrevOrNext} key={index} onClick={() => handleDayClick(day)}>
                    {day.getDate()}
                </S.DayButton>
            )
        });
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }}>
            <div style={{
                display: 'flex',
            }}>
                <input type="text" value={selectedStartDate ? selectedStartDate.toLocaleDateString() : ''} />
                <input type="text" value={selectedEndDate ? selectedEndDate.toLocaleDateString() : ''} />
            </div>
            <div style={{
                display: 'flex',
                gap: '10px',
            }}>
                <S.CalendarContainer>
                    <S.CalendarContent>
                        <button onClick={handlePrevMonth}>Prev</button>
                        <div>
                            {nameOfMonth(currentMonth)} - {currentYear}
                        </div>
                    </S.CalendarContent>
                    <S.DaysWeekContainer>
                        {daysCurrentMonth.slice(0, 7).map((day, index) => {
                            return (
                                <p key={index}>
                                    {daysOnWeekend(day)}
                                </p>
                            )
                        }
                        )}
                        {renderMonth(daysCurrentMonth, currentMonth)}
                    </S.DaysWeekContainer>
                </S.CalendarContainer>
                <S.CalendarContainer>
                    <S.CalendarContent>
                        <div>
                            {nameOfMonth(currentMonth + 1)} - {currentYear}
                        </div>
                        <button onClick={handleNextMonth}>Next</button>
                    </S.CalendarContent>
                    <S.DaysWeekContainer>
                        {daysNextMonth.slice(0, 7).map((day, index) => {
                            return (
                                <p key={index}>
                                    {daysOnWeekend(day)}
                                </p>
                            )
                        }
                        )}
                        {renderMonth(daysNextMonth, currentMonth + 1)}
                    </S.DaysWeekContainer>
                </S.CalendarContainer>

            </div>
        </div>
    );
};


